import { FormEvent, useState } from "react";
import useAuth from "../useAuth/useAuth";
import Loading from "../helpers/Loading/Loading";
import {LoginRequestBody} from "@pcgerente-node/pcg-comun"
const LoginForm = ()=> {
    const { login } = useAuth();

    const [show, setShow] = useState(false)
    const [state,setState] = useState({...new LoginRequestBody('', ''),error: ""})

    const HandleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        const btnLogin = window.document.getElementById("btn-login-form") as HTMLButtonElement
        if(btnLogin){
            btnLogin.disabled = true
            if (state.password.length>0 && state.usuario.length > 0) {
                try {
                    await login(state.usuario, state.password)
                } catch (error) {

                    if(error instanceof Error){

                        setState({...state, error: error.message})                    
                    }
                }
            }
            btnLogin.disabled = false
        }
    }

    function handleChanges(name: "usuario"|"password", value: string){
        setState({
            ...state,
            [name]: value
        })
    }
    return (
        state?
        <form onSubmit={(e) => HandleSubmit(e)} className="text-left">
            <div className="form">

                <div id="username-field" className="field-wrapper input">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                    <input 
                        onChange={(e) => handleChanges("usuario",e.target.value) } 
                        value={state.usuario} 
                        id="username" 
                        name="username" 
                        type="text" 
                        className="form-control" 
                        placeholder="Username" 
                        />
                </div>

                <div id="password-field" className="field-wrapper input mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-lock"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                    <input 
                    id="password" 
                    name="password" 
                    type={show?"text":"password"}
                    className="form-control"
                    placeholder="Password" 
                    onChange={(e) => handleChanges("password", e.target.value) } 
                    value={state.password} />
                </div>
                <div className="d-sm-flex justify-content-between mb-2">
                    <div className="field-wrapper toggle-pass" >
                        <p className="d-inline-block">Mostrar Contraseña</p>
                        <label className="switch s-primary">
                            <input type="checkbox" id="toggle-password" className="d-none" onClick={() => setShow(!show)} />
                            <span className="slider round"></span>
                        </label>
                    </div>
                    <div className="field-wrapper d-flex justify-content-center">
                        <button type="submit" className="btn btn-primary" value="" id="btn-login-form">Log In</button>
                    </div>
                </div>

                <div className={`field-wrapper text-center keep-logged-in ${state.error? "mt-1": ""}`}>
                    <div>
                        <span className={`text-danger `} >{state.error}</span>
                    </div>
                </div>
            </div>
        </form>
        :<Loading/>
    )
}


export default LoginForm